"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrometheusEditorHeader = exports.signoutAndLaunchSalesforceLoginDialog = exports.doOAuthSignIn = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
var oauth_credentials_service_1 = require("@tableau/oauth-credentials-service");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var TagHelpers_1 = require("../Tag/TagHelpers");
var RootReducer_1 = require("../app/RootReducer");
var DeployMenuIcon_1 = require("../img/DeployMenuIcon");
var NavigationArrowRight_1 = require("../img/NavigationArrowRight");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var SubspaceSlice_1 = require("../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var styles = require("../styles/NavigationPanel");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var LeftPaneHeaderComponent_1 = require("./LeftPaneHeaderComponent");
var StateSelectors_1 = require("./StateSelectors");
var Index_1 = require("./base/Index");
var ModelResultMetadata_1 = require("./model-results/nav/ModelResultMetadata");
var ModelResultNavSubmenu_1 = require("./model-results/nav/ModelResultNavSubmenu");
var doOAuthSignIn = function (server, handleOnCredentialsAdded) {
    // Launch OAuth sign in dialog
    oauth_credentials_service_1.OAuthCredentialsService.AddCredential({
        bypassBeforeConnectingDialog: true,
        connectionType: 'salesforce',
        connectionSubType: 'predictivemodeling',
        onCancel: function () { },
        onCredentialAdded: handleOnCredentialsAdded,
        shouldKeepWindowOpen: false,
        sendEventFn: function () { },
        sessionLanguage: server.serverSessionLanguage,
        sessionServerVersionBuild: server.sessionServerVersionBuild,
        sessionServerVersionPlatform: server.sessionServerVersionPlatform,
        connectionTypeDisplay: Localize_1.Messages.oAuthConnectionTypeDisplay(),
        helpServiceExternalVersion: '',
        supportsGenericAuth: false,
    });
};
exports.doOAuthSignIn = doOAuthSignIn;
var signoutAndLaunchSalesforceLoginDialog = function (server, handleOnCredentialsAdded) {
    (0, TagHelpers_1.DeleteSalesforceUserCredentials)({}).then(function (response) {
        if (response.isSuccessful) {
            (0, exports.doOAuthSignIn)(server, handleOnCredentialsAdded);
        }
        else {
            (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.salesforceLogoutError());
        }
    }, function (reason) {
        (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.salesforceLogoutError());
        console.log(reason);
    });
};
exports.signoutAndLaunchSalesforceLoginDialog = signoutAndLaunchSalesforceLoginDialog;
var PrometheusEditorHeader = function () {
    var subspace = (0, RootReducer_1.useAppSelector)(function (state) { return state.subspace; }).subspace;
    var dispatch = (0, react_redux_1.useDispatch)();
    var modelSuccessfullyTrained = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelSucceededTraining);
    var objectivesDefined = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelObjectivesDefined);
    var prepDataSourceStatus = (0, RootReducer_1.useAppSelector)(StateSelectors_1.selectPrepDataSourceStatus);
    var modelDeployed = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelDeployed);
    var navigateToSubspace = function (type) {
        if (type !== subspace) {
            dispatch((0, SubspaceSlice_1.setSubspace)(type));
        }
    };
    var navigationMenuItems = [
        {
            subspace: Utils_1.SubspaceType.Connect,
            header: Localize_1.Messages.connectToData(),
            icon: '1',
            onClick: function () { return navigateToSubspace(Utils_1.SubspaceType.Connect); },
            testId: TestIds_1.CONNECT_BUTTON_TEST_ID,
        },
        {
            subspace: Utils_1.SubspaceType.Define,
            header: Localize_1.Messages.defineObjective(),
            icon: '2',
            onClick: function () { return navigateToSubspace(Utils_1.SubspaceType.Define); },
            disabled: prepDataSourceStatus === Utils_1.PrepDataSourceStatus.flowNotPublished || prepDataSourceStatus === Utils_1.PrepDataSourceStatus.columnsNotReceived,
            testId: TestIds_1.DEFINE_BUTTON_TEST_ID,
        },
        {
            subspace: Utils_1.SubspaceType.Train,
            header: Localize_1.Messages.trainModel(),
            icon: '3',
            onClick: function () { return navigateToSubspace(Utils_1.SubspaceType.Train); },
            disabled: !objectivesDefined ||
                prepDataSourceStatus === Utils_1.PrepDataSourceStatus.flowNotPublished ||
                prepDataSourceStatus === Utils_1.PrepDataSourceStatus.columnsNotReceived,
            testId: TestIds_1.TRAIN_BUTTON_TEST_ID,
        },
        {
            subspace: Utils_1.SubspaceType.Results,
            header: Localize_1.Messages.modelResults(),
            icon: '4',
            onClick: function () { return navigateToSubspace(Utils_1.SubspaceType.Results); },
            submenu: React.createElement(ModelResultNavSubmenu_1.default, null),
            disabled: !modelSuccessfullyTrained,
            testId: TestIds_1.RESULTS_BUTTON_TEST_ID,
        },
        {
            subspace: Utils_1.SubspaceType.Deploy,
            header: Localize_1.Messages.deployModel(),
            icon: React.createElement(DeployMenuIcon_1.DeployMenuIcon, null),
            onClick: function () { return navigateToSubspace(Utils_1.SubspaceType.Deploy); },
            disabled: !modelSuccessfullyTrained && !modelDeployed,
            testId: TestIds_1.DEPLOY_BUTTON_TEST_ID,
        },
    ];
    var nextStepVisible = subspace < navigationMenuItems.length - 1;
    var renderNextStep = function () {
        var nextStepDisabled = nextStepVisible && navigationMenuItems[subspace + 1].disabled;
        return (React.createElement("div", { className: styles.navNextStepContainer },
            Localize_1.Messages.nextStepButton(),
            ":",
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, testId: TestIds_1.NEXT_STEP_BUTTON_TEST_ID, onClick: function () { return navigationMenuItems[subspace + 1].onClick(); }, className: styles.navNextStepButton, disabled: nextStepDisabled },
                React.createElement("span", null, navigationMenuItems[subspace + 1].header),
                React.createElement(NavigationArrowRight_1.NavigationArrowRight, null))));
    };
    var renderFooter = function () {
        // TODO: Deploy subspace has a different type of metadata
        // Create a more generic type of metadata which can be reused by both result and deploy subspace
        if (subspace === Utils_1.SubspaceType.Results || subspace === Utils_1.SubspaceType.Deploy) {
            return React.createElement(ModelResultMetadata_1.default, null);
        }
        return null;
    };
    return (React.createElement(Index_1.SideNavigationPanel, null,
        React.createElement(Index_1.SideNavigationPanel.Header, null,
            React.createElement(LeftPaneHeaderComponent_1.LeftPaneHeaderComponent, null)),
        React.createElement(Index_1.SideNavigationPanel.Menu, null,
            React.createElement(Index_1.NavigationTracker, { navigationItems: navigationMenuItems })),
        nextStepVisible && React.createElement(Index_1.SideNavigationPanel.Body, null, renderNextStep()),
        React.createElement(Index_1.SideNavigationPanel.Footer, null, renderFooter())));
};
exports.PrometheusEditorHeader = PrometheusEditorHeader;
//# sourceMappingURL=PrometheusEditorHeader.js.map